import React, { memo } from "react";
import { OverlayTrigger } from "react-bootstrap";

import { BubbleIcon } from "../icons";
import { renderTooltip } from "../StyledTooltip/StyledTooltip";

interface IConversationIndicatorProps {
  value: number;
  popupText?: string;
}

const ConversationIndicator: React.FC<IConversationIndicatorProps> = memo(
  ({ value, popupText }) => {
    if (popupText) {
      return (
        <OverlayTrigger placement="bottom" overlay={renderTooltip(popupText)}>
          <div data-testid="indicator" className="d-inline-block">
            <span className="me-1">
              <BubbleIcon />
            </span>
            {value}
          </div>
        </OverlayTrigger>
      );
    }
    return (
      <div className="d-inline-block">
        <span className="me-1">
          <BubbleIcon />
        </span>
        {value}
      </div>
    );
  },
);

export { ConversationIndicator };
